<template>
  <a-modal title="碎片配置"
           :open="modal"
           :confirloading="loading"
           :mask-closable="false"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">

    <div v-for="(v, i) in conf" :key="i" class="dvd">
      <a-space>
        <span>卡片ID</span>
        <a-input-number size="small" v-model:value="v.id" min="1"/>

        <span>碎片</span>
        <a-input-number size="small" v-model:value="v.v" min="1"/>

        <a-button danger size="small" @click="delInCk(i)">-</a-button>
      </a-space>
    </div>

    <a-button size="small" type="primary" @click="addInCk">添加卡片</a-button>

  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message, Modal} from 'ant-design-vue'

const modal = ref(false)
const loading = ref(false)

const conf = ref({})

function openCk() {
  axios.get('/config/shard').then((res) => {
    if (res.code === 1) {
      let tmp = []
      for (let i in res.data) {
        tmp.push({
          id: i,
          v: res.data[i],
        })
      }
      conf.value = tmp
    }
    modal.value = true
  })
}

function addInCk() {
  conf.value.push({
    id: 0,
    v: 0,
  })
}

function delInCk(idx) {
  Modal.confirm({
    content: '确定删除吗',
    okText: '确定',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      conf.value.splice(idx, 1)
    },
  })
}

function okCk() {
  loading.value = true
  let tmp = {}
  for (const i of conf.value) {
    tmp[i.id] = i.v
  }
  axios.post('/config/shard', {
    v: tmp,
    c: 1,
  }).then((res) => {
    if (res.code === 1) {
      message.success('操作成功')
    }
    modal.value = false
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

defineExpose({openCk})
</script>

<style scoped>
.dvd {
  margin-bottom: 5px;
}

.dvd:last-child {
  margin-bottom: 0;
}
</style>
